import React, { useEffect } from "react";
import "./bronsonDropdown.css";

const BronsonDropdown = ({
  isDisabled,
  options,
  id,
  setOptionState,
  value,
  placeholder,
  dataTestId,
}) => {
  // setOptionState is a prop that expects a setState function inherited from
  // the parent of BronsonDropdown in order to set a state based on a selected option

  const listOptions = (options) => {
    return options.map((option) => {
      return (
        <option className="dropdown-option" value={option.abbreviation} key={option.name} data-test-id={option.name}>
          {option.name}
        </option>
      );
    });
  };
  const handleChange = (event) => {
    setOptionState(event.target.value);
  };

  useEffect(() => {
    typeof setOptionState !== "function" &&
      console.error(
        'BronsonDropdown prop "setOptionState" expects a function that updates a state variable, as those used by the useState() React Hook, this must be declared first in the parent component and inherited to BronsonDropdown as a prop'
      );
  }, [setOptionState]);

  return (
    <div
      id="dropdown-wrapper"
      className="c-input  c-input--select"
      data-test-id={dataTestId}
    >
      <select
        className="c-input__input select-dropdown"
        name={id}
        id={id}
        disabled={isDisabled}
        value={value}
        defaultValue={placeholder}
        onChange={handleChange}
        data-test-id="dropdown"
        aria-label="states-dropdown"
      >
        <option className="dropdown-option" disabled data-test-id='SelectStatePlaceholder'>
          {placeholder}
        </option>
        {options
          ? listOptions(options)
          : console.error(
              'There is no options added to the dropdown, you must pass them as a prop called "options" containing an array to the BronsonDropdown component'
            )}
      </select>
    </div>
  );
};

export default BronsonDropdown;
